import { safeParseNullDefault } from 'shouldve-been-js';

class Tenant {

    private _tenantId: string;
    private _displayName: string;
    private _tunnelUrl: string;

    public constructor(tenantId: string, displayName: string, tunnelUrl: string) {

        this._tenantId = tenantId;
        this._displayName = displayName;
        this._tunnelUrl = tunnelUrl;
    }

    public get tenantId(): string {
        return this._tenantId;
    }

    public set tenantId(value: string) {
        this._tenantId = value;
    }

    public get displayName(): string {
        return this._displayName;
    }

    public set displayName(value: string) {
        this._displayName = value;
    }

    public get tunnelUrl(): string {
        return this._tunnelUrl;
    }

    public set tunnelUrl(value: string) {
        this._tunnelUrl = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Tenant | null {

        const tenantId: string | null = safeParseNullDefault<string>(json?.tenantId, '');
        const displayName: string | null = safeParseNullDefault<string>(json?.displayName, '');
        const tunnelUrl: string | null = safeParseNullDefault<string>(json?.tunnelUrl, '');

        if (tenantId === null || displayName === null || tunnelUrl === null) {
            return null;
        }

        return new Tenant(tenantId, displayName, tunnelUrl);
    }
}

export default Tenant;